<modal
  [modalId]="'bulk-edit-device'"
  [modalSize]="'md'"
  (close)="modalCleanup()">
  <div modal-title>
    <h3 class="d-inline text-capitalize" >Bulk Edit Devices</h3>
    <span class="bulk-edit-device-count">{{devices.length}} devices selected</span>
  </div>
  <div class="modal-inner h-100 pt-3" modal-inner>
    <form class="d-flex flex-column" id="form" [formGroup]="form" autocomplete="off">
      <div class="custom-field my-2">
        <label class="custom-field-label">Customer</label>
        <synx-dropdown formControlName="customerId" [selectOptions]="customerOptions" [fullWidth]="true"
          [placeholder]="'Select a customer'"></synx-dropdown>
        <synx-errors label="Please select a customer for the device"
          [show]="form.controls['customerId'].invalid && form.controls['customerId'].touched"></synx-errors>
      </div>

      <div class="custom-field-row my-2">
        <div class="custom-field">
          <label class="custom-field-label">Asset Type</label>
          <synx-dropdown formControlName="assetTypeId" [selectOptions]="assetTypeOptions" [fullWidth]="true"
            [placeholder]="'None'"></synx-dropdown>
        </div>
        <button type="button" class="custom-icon-button" (click)="openAssetTypeExpander(); $event.stopPropagation()" tabindex="-1">
            <i class="fas fa-lg fa-plus"></i>
        </button>
      </div>
      <lookup-form [lookupName]="'Asset Type'" [listTitle]="'Asset Types'" [controllerName]="'AssetType'" 
        *ngIf="addingAssetType" (sendCloseEvent)="assetTypeExpanderClosed($event)" (sendDeleteEvent)="assetTypeDeleted()">
      </lookup-form>

      <div class="custom-field my-2">
        <label class="custom-field-label" for="bulk-edit-device-api-key">API Key</label>
        <custom-text-input inputId="bulk-edit-device-api-key" formControlName="apiKey"
          placeholder="Leave blank to keep existing API keys"></custom-text-input>
      </div>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedEnabled.value, 'simple-slider': !showMixedEnabled.value}" formGroupName="enabled">
          <span>Enabled:</span>
          <span *ngIf="showMixedEnabled.value">
            <synx-checkbox formControlName="mixed" checkboxLabel="Mixed"
              (checkedChange)="updateMixedBooleanFromMixed($event, 'enabled')"></synx-checkbox>
          </span>
          <label class="switch" >
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enabled')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedEnabled.value}"></span>
          </label>
      </div>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedRecordingMap.value, 'simple-slider': !showMixedRecordingMap.value}"  formGroupName="enableRecordingMapRequest">
          <span>Recording Map Upload:</span>
          <span *ngIf="showMixedRecordingMap.value">
            <synx-checkbox formControlName="mixed" checkboxLabel="Mixed"
              (checkedChange)="updateMixedBooleanFromMixed($event, 'enableRecordingMapRequest')"></synx-checkbox>
          </span>
          <label class="switch">
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enableRecordingMapRequest')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedRecordingMap.value}"></span>
          </label>
      </div>

      <div class="labelled-slider" [ngClass]="{'slider-with-mixed': showMixedCameraSnap.value, 'simple-slider': !showMixedCameraSnap.value}"   formGroupName="enableCamerasSnapshotRequest">
          <span>Camera Snapshots Upload:</span>
          <span *ngIf="showMixedCameraSnap.value">
            <synx-checkbox formControlName="mixed" checkboxLabel="Mixed"
              (checkedChange)="updateMixedBooleanFromMixed($event, 'enableCamerasSnapshotRequest')"></synx-checkbox>
          </span>
          <label class="switch">
            <input type="checkbox" formControlName="value" (click)="updateMixedBooleanFromValue('enableCamerasSnapshotRequest')">
            <span class="slider round" [ngClass]="{'mixed-state': showMixedCameraSnap.value}"></span>
          </label>
      </div>

      <hr class="my-2" />

      <div class="bulk-edit-button-row mt-3 row px-3">
        <button class="custom-button custom-button-flat" id="edit" (click)="submitForm()" [disabled]="requestInProgress">
          Save Changes
        </button>
      </div>
    </form>
  </div>
</modal>